export const MainWrapper =
  'group text-14 font-Roboto hover:border-accentYellow mb-8 flex w-full cursor-pointer flex-col border-b border-machine2-75 bg-white pb-8'

export const OrderDateInfoWrapper = 'text-grayRegular flex w-full flex-row pb-2'

export const OrderDateContent = 'w-[90px]'

export const OrderNoContent = ''

export const OrderContentWrapper =
  'mb-4 flex w-full flex-col sm:mb-6 xl:h-[120px] xl:flex-row'

export const OrderLeftColWrapper =
  'flex w-full shrink-0 flex-col justify-between xl:w-[350px]'

export const OrderStatus = 'font-bold mb-2'

export const OrderTotalPrice =
  'font-Roboto font-bold leading-14 text-14 mt-4 pb-3 text-black'

export const OrderRightColWrapper = 'flex grow'

export const OrderProductsImageWrapper =
  'relative mr-[10px] aspect-square h-fit max-h-[120px] min-h-[60px] w-auto min-w-[60px] max-w-[120px] last-of-type:mr-0'

export const OrderProductImage = 'z-0 w-full'

export const OrderProductImageOverlayInfo =
  'z-1 font-Roboto text-20 sm:text-28 lg:text-36 bg-whiteTransparent absolute left-0 top-0 flex h-full w-full items-center justify-center text-black'

export const OrderActionsWrapper =
  'font-Roboto text-14 leading-12 tracking-3 cursor-pointer uppercase group-hover:underline underline-offset-8'
